import { useState, useEffect, useRef } from "react";
import { DUR, EASE } from "../theme/motion.js";

// Scroll-phase-aware reveal: adapts translateY, duration, easing based on
// which third of the page the element lives in (Extension → Branching → Exploitation)
export function useGrowthReveal(phase = 1, threshold = 0.12) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);

  const config = phase === 1
    ? { y: 80, dur: DUR.deliberate, ease: EASE.tipExtension }    // Extension: slow, big movement
    : phase === 2
    ? { y: 40, dur: DUR.moderate, ease: EASE.branching }         // Branching: moderate, snappier
    : { y: 20, dur: "300ms",      ease: EASE.anastomosis };      // Exploitation: quick, subtle

  return [ref, visible, config];
}
